// extracted by mini-css-extract-plugin
module.exports = {"dday":"JobDdayBadge_dday__fT7no"};